import anime from 'animejs';
import {Component} from '@lib/Component';

export class Filter extends Component {
  links: HTMLAnchorElement[] = [];
  content: Component | null = null;
  plus: HTMLDivElement | undefined | null = undefined;

  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
  }

  protected didMount() {
    const {trigger = '', content = ''} = this.element?.dataset || {};
    this.content = new Component();
    content &&
      this.content.mount(
        this.element?.querySelector(content) as HTMLDivElement,
      );

    const triggerElement = this.element?.querySelector(
      trigger,
    ) as HTMLDivElement;
    this.plus = triggerElement?.querySelector('.a-icon-plus') as HTMLDivElement;

    if (this.element) {
      this.links = [
        ...this.element.querySelectorAll('.m-category-collapse_item'),
      ] as HTMLAnchorElement[];

      this.links.map((link) => {
        link.addEventListener('click', this.onClick);
      });
    }
  }

  didUnmount() {
    this.links.map((link) => {
      link.removeEventListener('click', this.onClick);
    });
  }

  onClick() {
    this.slideUp();
  }

  slideUp() {
    this.element?.classList.remove('open');
    this.plus?.classList.remove('open');
    anime({
      duration: 300,
      easing: 'easeOutCubic',
      height: 0,
      targets: this.content?.element,
    });
  }
}
